export default {
  isEnterprise: true,
  portOptions: [],
  colorOptions: [],
  displaySettings: [],
  selectedPort: {},
  selectedMenuItem: "portSelect",
  storedMasterSearchCondition: {},
  enterpriseMenuItems: [
    {
      name: "港湾選択",
      path: "addon-gkmg-port-master-port-select",
    },
    {
      name: "代理店管理",
      path: "addon-gkmg-port-master-enterprise-agency-master",
    },
  ],
  enterprisePortMenuItems: [
    {
      name: "予定表一括取込",
      path: "addon-gkmg-port-master-destination-order-import",
      needUploadCsvPrivilege: true,
    },
    {
      name: "船舶管理",
      path: "addon-gkmg-port-master-vessel-master",
    },
  ],
  vesselsData: [],
  vesselsSubscribeList: [],
  gkmgPortMasterAuth: {},
};
